import { useEffect, useRef, useState, useContext } from 'react';

import styles from './SideMenuComponent.module.css'

import { GlobalContext } from "../../contexts/globalContext";
import { ProjectDetailsContext } from "../../contexts/projectDetailsContext";
import { AddConferenceProvider } from "../../contexts/addConferenceContext";

import ManageParticipantsComponent from '../popup/conferenceManageParticipants/ManageParticipantsComponent';
import MultitouchCalendarComponent from './featureScreens/MultitouchCalendarComponent';
import MultitouchCalculatorComponent from './featureScreens/MultitouchCalculatorComponent';
import ChatComponent from './ChatComponent';
import ConferenceSettingsComponent from './ConferenceSettingsComponent';
import CurrencyComponent from './featureScreens/CurrencyComponent';
import CustomMultitouchComponent from '../../files/CustomMultitouchComponent'
import QRCodeComponent from './featureScreens/QRCodeComponent';
import EditProfilePopup from '../EditProfilePopup';
import NotesComponent from './featureScreens/NotesComponent';
import TopicFilesEditComponent from './filesComponents/TopicFilesEditComponent';
import StationMapComponent from '../settings/StationMapComponent';

const SideMenuComponent = () => {

    const {
        setCurrentParticipantStream, setSharedFiles, setOpenedFiles, setCurrentConference, setCurrentParticipant, currentConference, socketRef, currentParticipant,
        setTopics, deskData, appWidth, appHeight, hasUnreadMessages, seeQrCode, setSeeQrCode, openEditProfile, setWaitingForJoining, setRefreshNotes, localSocketRef,
        showSettings, setShowSettings, iamSubAdministrator, setExtraScreenOpenConf
    } = useContext(GlobalContext)

    const { editConference, setEditConference, seeCurrencyFeature, setSeeCurrencyFeature, seeNoteFeature, setSeeNoteFeature } = useContext(ProjectDetailsContext)

    const intervalRef = useRef();
    const currencyRef = useRef()
    const isOpenCanvasRef = useRef(false);

    const [hour, setHour] = useState("00");
    const [minutes, setMinutes] = useState("00");
    const [dateString, setDateString] = useState("00");
    const [showEditParticipants, setShowEditParticipants] = useState(false);
    const [openStationsMap, setOpenStationsMap] = useState(false)
    const [onlineDevices, setOnlineDevices] = useState([])
    const [deviceToStart, setDeviceToStart] = useState()
    const [desksIdsForAnim, setDesksIdsForAnim] = useState([])
    const [openCalendar, setOpenCalendar] = useState(false)
    const [openCalculator, setOpenCalculator] = useState(false)
    const [openChat, setOpenChat] = useState(false)
    const [qrSharedParticipant, setQrSharedParticipant] = useState()

    const options = {
        appWidth: appWidth,
        appHeight: appHeight,
        minScale: 0.5,
        maxScale: 1.25,
    }

    useEffect(() => {
        const date = new Date();

        var hours = date.getHours();
        if (hours < 10) {
            hours = "0" + hours;
        }

        setHour(hours);

        var mins = date.getMinutes();
        if (mins < 10) {
            mins = "0" + mins;
        }
        setMinutes(mins);
        var d_str = date.toLocaleDateString("en-EN", { weekday: 'short' }) + " " + date.getDate() + " " + date.toLocaleDateString("en-EN", { month: 'short' }) + " " + date.getFullYear();
        setDateString(d_str);


        intervalRef.current = setInterval(() => {
            const date = new Date();

            var hours = date.getHours();
            if (hours < 10) {
                hours = "0" + hours;
            }
            setHour(hours);

            var mins = date.getMinutes();
            if (mins < 10) {
                mins = "0" + mins;
            }
            setMinutes(mins);
            var d_str = date.toLocaleDateString("en-EN", { weekday: 'short' }) + " " + date.getDate() + " " + date.toLocaleDateString("en-EN", { month: 'short' }) + " " + date.getFullYear();
            setDateString(d_str);
        }, 1000);

        socketRef.current.on('RECEIVE_SHARED_VCARD', (callback) => {
            if (currentConference._id === callback.conferenceId) {
                setQrSharedParticipant(callback.sender)
            }
        });

        socketRef.current.on('CONFERENCE_HIDE_VCARD', (conferenceId) => {
            if (currentConference._id === conferenceId) {
                setQrSharedParticipant(null)
            }
        });

        return () => {
            clearInterval(intervalRef.current);
        }

    }, []);

    const backButton_handler = () => {
        if (editConference) {
            socketRef.current.emit("GET_CONFERENCE_BY_ID", editConference._id, (callback) => {
                setTopics(callback.response.topics);
                currentConference.topics = callback.response.topics
            })
        }

        setShowEditParticipants(false);
        setEditConference(null);
        setExtraScreenOpenConf(false)
    }

    const exitMeetingButton_handler = () => {
        console.log("exitMeetingButton_handler");
        setSharedFiles([]);
        setOpenedFiles([]);
        setCurrentConference(null);
        setCurrentParticipant(null);
        setCurrentParticipantStream(null);
        setTopics(null);
        setWaitingForJoining(true)

    }

    const onDeskClicked = (deviceId, isOnline, currentDevice = false) => {
        if (isOnline) {
            if (currentDevice && currentConference) {
                socketRef.current.emit("STOP_CONFERENCE", currentConference._id)

                setTimeout(() => {
                    if (currentConference.type === "Presentation") {
                        socketRef.current.emit("PRESENTATION_EXIT", currentConference);
                    } else if (currentConference.type === "Meeting") {
                        socketRef.current.emit("MEETING_EXIT", currentConference);
                    }
                }, 300)

            }

            setTimeout(() => {
                socketRef.current.emit("SHUTDOWN", deviceId)
            }, 600)
        } else {
            setDeviceToStart(deviceId);
            if (localSocketRef.current?.connected) {
                localSocketRef.current.emit("systemInfo:wakeOnLan", deviceId);
            }
        }
    }

    return (
        <>
            <div style={{
                position: "absolute", userSelect: "none", display: "flex", flexDirection: "column", width: "135px", height: "auto", bottom: "0px", left: "0px", top: "0px",
                backgroundColor: "#292148", justifyContent: "center", alignItems: "center"
            }}>
                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px" }}>

                    <div style={{ font: "normal normal 600 71px/64px 'Bio Sans'", color: "#C3C2CA" }}> {hour}</div>
                    <div style={{ font: "normal normal 300 71px/64px 'Bio Sans'", color: "#C3C2CA" }}> {minutes}</div>
                    <div style={{ font: "normal normal 600 28px/32px Bio Sans", color: "#726FA8", margin: "25px 10px", textAlign: "center" }}> {dateString}</div>
                </div>

                <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>

                    <div style={{ cursor: "pointer", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: openChat ? 34 : 40, position: 'relative' }}
                        onClick={() => { setOpenChat(!openChat) }}>
                        {hasUnreadMessages > 0 && <div className={styles.unreadIndicator}>
                            <div className={styles.unreadIndicatorText}>{hasUnreadMessages}</div>
                        </div>}
                        <i className="fa-thin fa-messages" style={{ fontSize: "50px", color: openChat ? "#FFFFFF" : "#726FA8" }}></i>
                        <div style={{ font: "normal normal 600 18px/22px Bio Sans", color: openChat ? "#FFFFFF" : "#726FA8", margin: "10px", marginTop: "30px" }} >CHAT</div>
                        {openChat && <div className={styles.greenLine}></div>}
                    </div>

                    <div style={{ cursor: "pointer", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: openCalculator ? 34 : 40 }}
                        onClick={() => { setOpenCalculator(!openCalculator) }}
                    >
                        <i className="fa-thin fa-calculator" style={{ fontSize: "50px", color: openCalculator ? "#FFFFFF" : "#726FA8" }}></i>
                        <div style={{ font: "normal normal 600 18px/22px Bio Sans", color: openCalculator ? "#FFFFFF" : "#726FA8", margin: "10px", marginTop: "30px" }}>CALCULATOR</div>
                        {openCalculator && <div className={styles.greenLine}></div>}
                    </div>

                    <div style={{ cursor: "pointer", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: seeNoteFeature ? 34 : 40 }}
                        onClick={() => { setSeeNoteFeature(!seeNoteFeature); setRefreshNotes(true) }}>
                        <i className="fa-thin fa-notes" style={{ fontSize: "50px", color: seeNoteFeature ? "#FFFFFF" : "#726FA8" }}></i>
                        <div style={{ font: "normal normal 600 18px/22px Bio Sans", color: seeNoteFeature ? "#FFFFFF" : "#726FA8", margin: "10px", marginTop: "30px" }}>NOTES</div>
                        {seeNoteFeature && <div className={styles.greenLine}></div>}
                    </div>

                    <div style={{ cursor: "pointer", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: seeCurrencyFeature ? 34 : 40 }}
                        onClick={() => setSeeCurrencyFeature(!seeCurrencyFeature)}>
                        <i className="fa-thin fa-coins" style={{ fontSize: "50px", color: seeCurrencyFeature ? "#FFFFFF" : "#726FA8" }}></i>
                        <div style={{ font: "normal normal 600 18px/22px Bio Sans", color: seeCurrencyFeature ? "#FFFFFF" : "#726FA8", margin: "10px", marginTop: "30px" }}>CURRENCY</div>
                        {seeCurrencyFeature && <div className={styles.greenLine}></div>}
                    </div>

                    <div style={{ cursor: "pointer", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: openCalendar ? 34 : 40 }}
                        onClick={() => { setOpenCalendar(!openCalendar) }}
                    >
                        <i className="fa-thin fa-calendar-lines" style={{ fontSize: "50px", color: openCalendar ? "#FFFFFF" : "#726FA8" }}></i>
                        <div style={{ font: "normal normal 600 18px/22px Bio Sans", color: openCalendar ? "#FFFFFF" : "#726FA8", margin: "10px", marginTop: "30px" }}>CALENDAR</div>
                        {openCalendar && <div className={styles.greenLine}></div>}
                    </div>

                </div>

                {openCalendar && <MultitouchCalendarComponent setOpenCalendar={() => setOpenCalendar(false)} />}
                {openCalculator && <MultitouchCalculatorComponent setOpenCalculator={() => setOpenCalculator(false)} />}

                <ChatComponent open={openChat} setOpenChat={() => setOpenChat(false)} />


                {((currentConference?.type === "Conference" && currentConference?.topics[0]?.moderator._id === currentParticipant?._id) ||
                    iamSubAdministrator ||
                    ((currentConference?.type === "Presentation" || currentConference?.type === "Meeting") && currentParticipant?._id === currentConference.moderatedBy)) && deskData &&
                    <>
                        <div className={styles.anim} style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div style={{
                                color: `${showEditParticipants ? "white" : "#726FA8"}`, cursor: "pointer", width: "100%", display: "flex", flexDirection: "column",
                                alignItems: "center", marginBottom: "40px"
                            }}
                                onClick={() => {
                                    if (showEditParticipants) {
                                        backButton_handler()
                                    } else {
                                        setShowEditParticipants(true);
                                        setExtraScreenOpenConf(true)
                                        setEditConference(null);
                                        setShowSettings(false);
                                    }
                                }}>
                                <i className="fa-thin fa-users" style={{ fontSize: "50px" }}></i>
                                <div style={{ font: "normal normal 600 18px/22px Bio Sans", margin: "10px", marginTop: "20px" }}>ATTENDEES</div>
                            </div>

                            {!iamSubAdministrator && currentConference?.type !== "Meeting" && <div style={{
                                color: `${editConference ? "white" : "#726FA8"}`, cursor: "pointer", width: "100%", display: "flex", flexDirection: "column",
                                alignItems: "center", marginBottom: "40px"
                            }}
                                onClick={() => {
                                    if (!editConference) {
                                        setShowEditParticipants(false);
                                        setEditConference(currentConference);
                                        setShowSettings(false);
                                        setExtraScreenOpenConf(true)
                                    } else {
                                        backButton_handler()
                                    }

                                }}>
                                <i className="fa-thin fa-files" style={{ fontSize: "50px" }}></i>
                                <div style={{ font: "normal normal 600 18px/22px Bio Sans", margin: "10px", marginTop: "20px" }}>FILES</div>
                            </div>}

                            <div style={{
                                color: `${showSettings ? "white" : "#726FA8"}`, cursor: "pointer", width: "100%", display: "flex", flexDirection: "column", alignItems: "center",
                                marginBottom: "40px"
                            }}
                                onClick={() => {
                                    if (showSettings) {
                                        setShowSettings(false)
                                    } else {
                                        setShowSettings(true)
                                        if (editConference || showEditParticipants) {
                                            backButton_handler()
                                        }
                                    }
                                }}>
                                <i className="fa-thin fa-cog" style={{ fontSize: "50px" }}></i>
                                <div style={{ font: "normal normal 600 18px/22px Bio Sans", margin: "10px", marginTop: "20px" }}>SETTINGS</div>
                            </div>

                        </div>

                        <ConferenceSettingsComponent showSettings={showSettings} openStationsMap={openStationsMap} setOpenStationsMap={setOpenStationsMap} onlineDevices={onlineDevices}
                            onDeskClicked={onDeskClicked} setOnlineDevices={setOnlineDevices} deviceToStart={deviceToStart} setDeviceToStart={setDeviceToStart} desksIdsForAnim={desksIdsForAnim}
                            setDesksIdsForAnim={setDesksIdsForAnim} />
                    </>
                }
                {
                    ((currentConference?.type === "Meeting" && currentConference?.moderatedBy !== currentParticipant?._id) || !deskData) &&
                    <div style={{ color: "#726FA8", cursor: "pointer", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "40px" }}
                        onClick={() => exitMeetingButton_handler()}>
                        <i className="fa-solid fa-arrow-right-to-bracket" style={{ fontSize: "50px" }}></i>
                        <div style={{ font: "normal normal 600 18px/22px Bio Sans", margin: "10px", marginTop: "20px" }}>LEAVE</div>
                    </div>
                }
            </div>
            {showEditParticipants &&
                <ManageParticipantsComponent isConference={true} />
            }

            {editConference &&
                <AddConferenceProvider>
                    <TopicFilesEditComponent />
                </AddConferenceProvider>
            }

            {deskData && openStationsMap && <StationMapComponent openStationsMap={openStationsMap} setOpenStationsMap={setOpenStationsMap} onlineDevices={onlineDevices}
                deviceToStart={deviceToStart} desksIdsForAnim={desksIdsForAnim} setDesksIdsForAnim={setDesksIdsForAnim} onDeskClicked={onDeskClicked} />}


            {seeCurrencyFeature && <CustomMultitouchComponent ref={currencyRef} dragGesture={false} x={1060} y={790} width={951} height={560} options={options}
                onMinScaleReached={() => setSeeCurrencyFeature(false)} dragGestureMouse={true} dragBox={{ x: 0, y: 0, width: 951, height: 100 }} isOpenCanvasRef={isOpenCanvasRef}>
                <CurrencyComponent setSeeCurrencyFeature={setSeeCurrencyFeature} />
            </CustomMultitouchComponent>}

            {seeNoteFeature && <NotesComponent setSeeNoteFeature={setSeeNoteFeature} />}

            {seeQrCode && <CustomMultitouchComponent ref={currencyRef} dragGesture={false} x={appWidth - 806} y={appHeight - 1184} width={728} height={1127} options={options}
                onMinScaleReached={() => setSeeQrCode(false)} >
                <QRCodeComponent setSeeQrCode={setSeeQrCode} participant={currentParticipant} />
            </CustomMultitouchComponent>}

            {qrSharedParticipant && <CustomMultitouchComponent ref={currencyRef} dragGesture={false} x={appWidth - 806} y={appHeight - 1080} width={728} height={1023} options={options}
                onMinScaleReached={() => setSeeQrCode(false)} >
                <QRCodeComponent setSeeQrCode={setSeeQrCode} isShared={true} participant={qrSharedParticipant} setQrSharedParticipant={setQrSharedParticipant} />
            </CustomMultitouchComponent>}

            {openEditProfile && <EditProfilePopup currentUser={currentParticipant} setCurrentUser={setCurrentParticipant} />}
        </>
    );
}

export default SideMenuComponent;